(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["artisan-directory"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.adReady === 'true') return;
    root.dataset.adReady = 'true';

    var items    = Array.prototype.slice.call(root.querySelectorAll('[data-ad-item]'));
    var searchEl = root.querySelector('[data-ad-search]');
    var regionEl = root.querySelector('[data-ad-region]');
    var awardEl  = root.querySelector('[data-ad-award]');
    var chips    = Array.prototype.slice.call(root.querySelectorAll('[data-ad-craft]'));
    var countEl  = root.querySelector('[data-ad-count]');
    var clearEl  = root.querySelector('[data-ad-clear]');
    var emptyEl  = root.querySelector('[data-ad-empty]');
    var moreWrap = root.querySelector('[data-ad-more]');
    var loadEl   = root.querySelector('[data-ad-load]');

    var batch   = parseInt(root.dataset.batch, 10) || 20;
    var visible = parseInt(root.dataset.initial, 10) || batch;
    var craft   = '';

    function activeFilters() {
      var q = searchEl ? searchEl.value.trim().toLowerCase() : '';
      var r = regionEl ? regionEl.value : '';
      var a = awardEl ? awardEl.value : '';
      return { q: q, r: r, c: craft, a: a, any: !!(q || r || a || craft) };
    }

    function matchesAward(el, a) {
      if (!a) return true;
      var val = el.dataset.award || '';
      if (a === '__any') return val !== '';
      return val === a;
    }

    function matchesQuery(el, q) {
      if (!q) return true;
      var hay = el.dataset.search || el.dataset.name || '';
      return hay.indexOf(q) !== -1;
    }

    function setChip(chip, on) {
      chip.classList.toggle('is-active', on);
      chip.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    function render() {
      var f = activeFilters();
      var shown = 0;
      var matched = 0;

      items.forEach(function (el) {
        var ok =
          matchesQuery(el, f.q) &&
          (!f.c || el.dataset.craft === f.c) &&
          (!f.r || el.dataset.region === f.r) &&
          matchesAward(el, f.a);

        if (!ok) {
          el.classList.add('is-filtered');
          el.classList.add('ad-card--over');
          return;
        }
        matched++;
        el.classList.remove('is-filtered');
        if (shown < visible) {
          el.classList.remove('ad-card--over');
          shown++;
        } else {
          el.classList.add('ad-card--over');
        }
      });

      if (countEl) {
        countEl.textContent = matched === 0
          ? 'No artisans found'
          : 'Showing ' + shown + ' of ' + matched + ' ' + (matched === 1 ? 'artisan' : 'artisans');
      }
      if (emptyEl) emptyEl.hidden = matched !== 0;
      if (moreWrap) moreWrap.hidden = shown >= matched;
      if (clearEl) clearEl.hidden = !f.any;
    }

    function reset() {
      visible = parseInt(root.dataset.initial, 10) || batch;
    }

    if (searchEl) {
      var t;
      searchEl.addEventListener('input', function () {
        clearTimeout(t);
        t = setTimeout(function () { reset(); render(); }, 160);
      });
    }
    if (regionEl) {
      regionEl.addEventListener('change', function () { reset(); render(); });
    }
    if (awardEl) {
      awardEl.addEventListener('change', function () { reset(); render(); });
    }
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        craft = chip.dataset.adCraft || '';
        chips.forEach(function (c) { setChip(c, c === chip); });
        reset();
        render();
      });
    });
    if (loadEl) {
      loadEl.addEventListener('click', function () {
        visible += batch;
        render();
      });
    }
    if (clearEl) {
      clearEl.addEventListener('click', function () {
        if (searchEl) searchEl.value = '';
        if (regionEl) regionEl.value = '';
        if (awardEl) awardEl.value = '';
        craft = '';
        chips.forEach(function (c, i) { setChip(c, i === 0); });
        reset();
        render();
      });
    }

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-artisan-directory]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["artisan-honours"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Load more — masonry and cards only. */
  function initMore(root) {
    var loadEl = root.querySelector('[data-hn-load]');
    if (!loadEl || root.dataset.hnMoreReady === 'true') return;
    root.dataset.hnMoreReady = 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-hn-item]'));
    var wrap  = root.querySelector('[data-hn-more]');
    var batch = parseInt(root.dataset.batch, 10) || 8;
    var shown = parseInt(root.dataset.initial, 10) || batch;
    loadEl.addEventListener('click', function () {
      shown += batch;
      items.forEach(function (el, i) { if (i < shown) el.classList.remove('hn-card--over'); });
      if (shown >= items.length && wrap) wrap.hidden = true;
    });
  }

  /* Filmstrip — drive the progress thumb from real scroll position, and add
     drag-to-pan on pointer devices where there is no touch surface. */
  function initStrip(root) {
    var track = root.querySelector('[data-hn-track]');
    if (!track || root.dataset.hnStripReady === 'true') return;
    root.dataset.hnStripReady = 'true';
    var thumb = root.querySelector('[data-hn-thumb]');

    function sync() {
      if (!thumb) return;
      var max = track.scrollWidth - track.clientWidth;
      var bar = thumb.parentElement;
      if (max <= 1) { bar.style.display = 'none'; return; }
      bar.style.display = '';
      var frac = track.clientWidth / track.scrollWidth;
      var w = Math.max(40, Math.round(bar.clientWidth * frac));
      thumb.style.width = w + 'px';
      var travel = bar.clientWidth - w;
      thumb.style.transform = 'translateX(' + Math.round((track.scrollLeft / max) * travel) + 'px)';
    }

    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (window.ResizeObserver) new ResizeObserver(sync).observe(track);
    Array.prototype.forEach.call(track.querySelectorAll('img'), function (img) {
      if (!img.complete) img.addEventListener('load', sync, { once: true });
    });
    sync();

    /* Belt and braces alongside the CSS: some browsers still raise dragstart. */
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false;
      startX = e.clientX; startLeft = track.scrollLeft;
      track.style.cursor = 'grabbing';
      /* Deliberately NOT using setPointerCapture here. Capturing retargets the
         click that follows to the track, so it never reaches the <a> and every
         artisan link goes dead. Suppressing native image drag (above) is what
         keeps the pointermove stream alive. */
    });
    track.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    function release() { down = false; track.style.cursor = ''; }
    track.addEventListener('pointerup', release);
    track.addEventListener('pointerleave', release);
    /* Suppress the click that follows a drag, or panning opens a profile. */
    track.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-honours]').forEach(function (root) {
      initMore(root); initStrip(root);
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bespoke-enquiry"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('#enquire .benq-form, #enquire form').forEach(function (formEl) {
    var steps = formEl.querySelectorAll('[data-benq-step]');
    if (!steps.length) return;
    var count = formEl.querySelector('[data-benq-count]');
    var next = formEl.querySelector('[data-benq-next]');
    var back = formEl.querySelector('[data-benq-back]');

    function show(n) {
      steps.forEach(function (s) {
        s.classList.toggle('is-active', s.getAttribute('data-benq-step') === String(n));
      });
      if (count) count.textContent = 'Step ' + n + ' of ' + steps.length;
    }
    if (next) next.addEventListener('click', function () {
      var sel = formEl.querySelector('#benqInterest');
      if (sel && !sel.value) { sel.focus(); sel.style.borderColor = '#873F2B'; return; }
      show(2);
    });
    if (back) back.addEventListener('click', function () { show(1); });

    var ta = formEl.querySelector('#benqDetails');
    var chars = formEl.querySelector('[data-benq-chars]');
    if (ta && chars) ta.addEventListener('input', function () { chars.textContent = ta.value.length; });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-circles"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.ccReady === 'true') return;
    root.dataset.ccReady = 'true';

    var wrap = root.querySelector('[data-cc-more]');
    if (!wrap) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-cc-item]'));
    var loadBtn = root.querySelector('[data-cc-load]');
    var allBtn = root.querySelector('[data-cc-all]');
    var batch = parseInt(root.dataset.batch, 10) || 12;
    var visible = parseInt(root.dataset.initial, 10) || batch;

    function render(focusFrom) {
      items.forEach(function (el, i) {
        el.classList.toggle('cc-over', i >= visible);
      });
      wrap.hidden = visible >= items.length;
      /* keyboard users land on the first newly revealed circle */
      if (typeof focusFrom === 'number' && items[focusFrom]) {
        items[focusFrom].setAttribute('tabindex', '-1');
        items[focusFrom].focus({ preventScroll: true });
      }
    }

    if (loadBtn) {
      loadBtn.addEventListener('click', function () {
        var from = visible;
        visible += batch;
        render(from);
      });
    }
    if (allBtn) {
      allBtn.addEventListener('click', function () {
        var from = visible;
        visible = items.length;
        render(from);
      });
    }

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-circle-cats]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-circles-slider"] && !Shopify.designMode) return;
  try {
    
/* Load more — reveals tiles already present in the DOM. */
(function () {
  function init(root) {
    if (root.dataset.ccircMoreReady === 'true') return;
    root.dataset.ccircMoreReady = 'true';

    var wrap = root.querySelector('[data-ccirc-morewrap]');
    if (!wrap) return;

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-ccirc-item]'));
    var batch = parseInt(root.dataset.batch, 10) || 12;
    var shown = parseInt(root.dataset.initial, 10) || batch;

    function render(focusFrom) {
      items.forEach(function (el, i) { el.classList.toggle('ccirc-over', i >= shown); });
      wrap.hidden = shown >= items.length;
      if (typeof focusFrom === 'number' && items[focusFrom]) {
        items[focusFrom].setAttribute('tabindex', '-1');
        items[focusFrom].focus({ preventScroll: true });
      }
    }

    var load = root.querySelector('[data-ccirc-load]');
    if (load) load.addEventListener('click', function () {
      var from = shown; shown += batch; render(from);
    });

    var all = root.querySelector('[data-ccirc-all]');
    if (all) all.addEventListener('click', function () {
      var from = shown; shown = items.length; render(from);
    });

    render();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-ccirc-more]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

(function () {
  document.querySelectorAll('[data-ccirc]').forEach(function (track) {
    /* progress bar (uses the pre-rendered bar right after the viewport) */
    var bar = track.parentElement.querySelector('.ccirc-progresswrap .tscroll-progress');
    var fill = bar ? bar.firstElementChild : null;
    function update() {
      if (!bar) return;
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 2) { bar.classList.add('is-hidden'); return; }
      bar.classList.remove('is-hidden');
      var pct = track.scrollLeft / max;
      var base = track.clientWidth / track.scrollWidth;
      fill.style.width = (base + (1 - base) * pct) * 100 + '%';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* drag-to-scroll — engages after 6px so plain clicks still navigate */
    var down = false, dragging = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; dragging = false;
      startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 6) {
        dragging = true;
        track.style.scrollBehavior = 'auto';
        track.classList.add('is-dragging');
      }
      if (dragging) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (dragging) {
        track.style.scrollBehavior = '';
        setTimeout(function () { track.classList.remove('is-dragging'); dragging = false; }, 50);
      }
    });
    track.addEventListener('dragstart', function (e) { if (dragging) e.preventDefault(); });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["film-band"] && !Shopify.designMode) return;
  try {
    
(function () {
  var REDUCED = window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function flag(stage, name, dflt) {
    var v = stage.getAttribute('data-' + name);
    if (v === null || v === '') return dflt;
    return v !== 'false';
  }

  function options(stage) {
    return {
      autoplay: flag(stage, 'autoplay', false),
      loop:     flag(stage, 'loop', true),
      muted:    flag(stage, 'muted', true),
      controls: flag(stage, 'controls', true)
    };
  }

  function youtubeSrc(stage, opts, forceMute) {
    var src = (stage.getAttribute('data-src') || '').trim();
    var id  = stage.getAttribute('data-youtube-id') || '';
    var u   = src + (src.indexOf('?') > -1 ? '&' : '?') + 'autoplay=1';
    if (opts.muted || forceMute) u += '&mute=1';
    if (opts.loop && id) u += '&loop=1&playlist=' + encodeURIComponent(id);
    if (!opts.controls) u += '&controls=0';
    return u;
  }

  function build(stage, opts, forceMute) {
    var kind = stage.getAttribute('data-kind');
    var src  = (stage.getAttribute('data-src') || '').trim();
    if (!src) return null;

    if (kind === 'youtube') {
      var frame = document.createElement('iframe');
      frame.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('title', 'Film');
      frame.src = youtubeSrc(stage, opts, forceMute);
      return frame;
    }

    var video = document.createElement('video');
    video.setAttribute('playsinline', '');
    video.playsInline = true;
    if (opts.controls) video.setAttribute('controls', '');
    if (opts.loop) { video.setAttribute('loop', ''); video.loop = true; }
    // Browsers only allow autoplay on muted media, so an autoplaying film is
    // always muted at the start whatever the setting says.
    if (opts.muted || forceMute) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
    }
    video.setAttribute('autoplay', '');
    video.setAttribute('preload', 'auto');
    var poster = stage.querySelector('img.filmband-poster');
    if (poster && poster.currentSrc) video.setAttribute('poster', poster.currentSrc);
    video.src = src;
    return video;
  }

  function addUnmute(stage, video) {
    if (stage.querySelector('.filmband-unmute')) return;
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'filmband-unmute';
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor">' +
      '<path d="M4 9v6h4l5 4V5L8 9H4zm12.5 3a4.5 4.5 0 0 0-2.5-4v8a4.5 4.5 0 0 0 2.5-4z"/>' +
      '</svg><span>Sound on</span>';
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      video.muted = false;
      video.volume = 1;
      btn.remove();
    });
    stage.appendChild(btn);
  }

  function revert(stage, el) {
    if (el && el.parentNode) el.parentNode.removeChild(el);
    var u = stage.querySelector('.filmband-unmute');
    if (u) u.remove();
    stage.classList.remove('is-playing');
  }

  // play() rejects for two very different reasons and they need opposite
  // handling. NotAllowedError is the browser refusing autoplay outright — give
  // the poster back. AbortError only means the element was still loading when
  // we asked, which is the common case on a cold cache; wait for it to be ready
  // and ask once more rather than tearing down a film that is about to work.
  function tryPlay(el, onRefused) {
    var attempt = el.play();
    if (!attempt || !attempt.catch) return;
    attempt.catch(function (err) {
      if (err && err.name === 'NotAllowedError') { onRefused(); return; }
      el.addEventListener('canplay', function () {
        var second = el.play();
        if (second && second.catch) second.catch(function () { onRefused(); });
      }, { once: true });
    });
  }

  // isAuto = started by the observer rather than by a click. On refusal we put
  // the poster back so the visitor still has something to press.
  function start(stage, isAuto) {
    if (stage.classList.contains('is-playing')) return;
    var opts = options(stage);
    var el = build(stage, opts, isAuto);
    if (!el) return;

    stage.appendChild(el);
    stage.classList.add('is-playing');

    if (isAuto && el.tagName === 'VIDEO' && !opts.muted && !opts.controls) {
      addUnmute(stage, el);
    }

    if (el.play) {
      tryPlay(el, function () {
        if (!isAuto) return;               // a click-started film keeps its frame
        revert(stage, el);
      });
    }
  }

  function watch(stage) {
    if (!('IntersectionObserver' in window)) { start(stage, true); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.disconnect();
        start(stage, true);
      });
    }, { threshold: 0.25 });
    io.observe(stage);
  }

  function init(stage) {
    if (stage.dataset.fbReady === 'true') return;
    stage.dataset.fbReady = 'true';

    stage.addEventListener('click', function () { start(stage, false); });
    var btn = stage.querySelector('[data-filmband-play]');
    if (btn) btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); start(stage, false); }
    });

    // Reduced-motion visitors keep the poster and press play themselves.
    if (flag(stage, 'autoplay', false) && !REDUCED) watch(stage);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-filmband]').forEach(init);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else { boot(); }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iconic-pieces"] && !Shopify.designMode) return;
  try {
    
(function(){
  document.querySelectorAll('[data-iconic]').forEach(function(sec){
    var track = sec.querySelector('[data-ip-track]');
    var fill = sec.querySelector('[data-ip-fill]');
    if (!track || !fill) return;

    function update(){
      var max = track.scrollWidth - track.clientWidth;
      var pct = max > 0 ? (track.scrollLeft / max) : 0;
      var base = max > 0 ? (track.clientWidth / track.scrollWidth) : 1;
      fill.style.width = (base + (1 - base) * pct) * 100 + '%';
    }
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();

    /* drag-to-scroll (desktop) — engages only after 6px of movement,
       so a plain click still opens the product */
    var down = false, dragging = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function(e){
      if (e.pointerType !== 'mouse') return;
      down = true; dragging = false;
      startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function(e){
      if (!down) return;
      var dx = e.clientX - startX;
      if (!dragging && Math.abs(dx) > 6){
        dragging = true;
        track.style.scrollBehavior = 'auto';   /* 1:1 drag, no easing lag */
        track.classList.add('is-dragging');
      }
      if (dragging) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function(){
      down = false;
      if (dragging){
        track.style.scrollBehavior = '';
        setTimeout(function(){ track.classList.remove('is-dragging'); dragging = false; }, 50);
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["india-map"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.imapReady === 'true') return;
    root.dataset.imapReady = 'true';

    /* ---- name plate on hover ---- */
    var canvas = root.querySelector('.imap-canvas');
    var tip = root.querySelector('[data-imap-tip]');
    if (canvas && tip) {
      root.querySelectorAll('[data-imap-state]').forEach(function (el) {
        function show() {
          tip.textContent = el.getAttribute('data-imap-state') || '';
          tip.style.left = (parseFloat(el.getAttribute('data-lx')) || 50) + '%';
          tip.style.top = (parseFloat(el.getAttribute('data-ly')) || 50) + '%';
          tip.classList.add('is-on');
        }
        function hide() { tip.classList.remove('is-on'); }
        el.addEventListener('mouseenter', show);
        el.addEventListener('mouseleave', hide);
        el.addEventListener('focus', show);
        el.addEventListener('blur', hide);
      });
    }

    /* ---- hovering the list lights up the shape on the map ---- */
    root.querySelectorAll('[data-imap-listitem]').forEach(function (a) {
      var h = a.getAttribute('data-imap-listitem');
      var shape = root.querySelector('use[href="#st-' + h + '"]');
      var target = shape ? shape.parentNode : null;
      if (!target || !target.classList) return;
      a.addEventListener('mouseenter', function () { target.classList.add('is-lit'); });
      a.addEventListener('mouseleave', function () { target.classList.remove('is-lit'); });
    });

    /* ---- intro popup ---- */
    var freq = root.getAttribute('data-imap-popup');
    var modal = root.querySelector('[data-imap-modal]');
    if (!freq || !modal) return;

    var KEY = 'toi:mapIntro';
    var seen = false;
    try {
      seen = freq === 'once'
        ? localStorage.getItem(KEY) === '1'
        : sessionStorage.getItem(KEY) === '1';
    } catch (e) { seen = false; }

    /* In the theme editor the merchant has to be able to see what they edit */
    var editor = !!(window.Shopify && window.Shopify.designMode);
    if (seen && !editor) return;

    var lastFocus = null;

    function onKey(e) {
      if (e.key === 'Escape') { close(); return; }
      if (e.key !== 'Tab') return;
      var f = modal.querySelectorAll('button, [href]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open() {
      lastFocus = document.activeElement;
      modal.hidden = false;
      requestAnimationFrame(function () { modal.classList.add('is-open'); });
      document.body.style.overflow = 'hidden';
      var cta = modal.querySelector('.imap-modal__cta');
      if (cta) cta.focus();
      document.addEventListener('keydown', onKey);
    }

    function close() {
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { modal.hidden = true; }, 320);
      try {
        if (freq === 'once') localStorage.setItem(KEY, '1');
        else sessionStorage.setItem(KEY, '1');
      } catch (e) { /* private mode — the popup simply shows again next time */ }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    modal.querySelectorAll('[data-imap-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    setTimeout(open, 550);
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-imap]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pull-quote"] && !Shopify.designMode) return;
  try {
    
(function () {
  var openBox = null;
  var lastFocus = null;

  function close() {
    if (!openBox) return;
    var f = openBox.querySelector('[data-pq-iframe]');
    var v = openBox.querySelector('[data-pq-video]');
    if (f) f.src = '';
    if (v) { v.pause(); v.currentTime = 0; }
    openBox.hidden = true;
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
    openBox = null;
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-pq-open]');
    if (trigger) {
      var box = document.querySelector('[data-pq-box="' + trigger.getAttribute('data-pq-open') + '"]');
      if (!box) return;
      close();
      lastFocus = trigger;
      var f = box.querySelector('[data-pq-iframe]');
      if (f) f.src = f.getAttribute('data-src');
      box.hidden = false;
      openBox = box;
      document.body.style.overflow = 'hidden';
      var c = box.querySelector('[data-pq-close]');
      if (c) c.focus();
      return;
    }
    if (e.target.closest('[data-pq-close]')) { close(); return; }
    if (openBox && e.target === openBox) close();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openBox) close();
  });
  document.addEventListener('shopify:section:unload', close);
})();

  } catch(e) { console.error(e); }
})();
})();
